//@flow
import React from 'react';
import FloatLabelInput from '../../Form/components/FloatLabelInput.react';

type Props = {
  title?:string,
  fieldName?:string,
  className?:string,
  required?:boolean,
  validations?:Object,
  placeholder?:string,
};

const defaultValidations = {
  isEmail: true,
  matchRegexp: /^[^@]{1,64}@.{3,254}$/,
  maxLength: 254,
};

const defaultProps = {
  title: 'Email',
  name: 'email',
  required: true,
  validations: {},
  validationError: 'This is not a valid email',
  value: '',
};

function _getInputProps(props:Props) {
  const inputProps = Object.assign({}, defaultProps, props);
  Object.assign(inputProps.validations, defaultValidations);

  delete inputProps.type;

  return inputProps;
}

export default function EmailField(props:Props) {
  return (
    <FloatLabelInput
      {..._getInputProps(props)}
      type="email"
      aria-label="email field"
    />
  );
}
